export default "/assets/Icon/credit-card.svg"